import { BASE_URL } from '@/app/utils/constant'

export const KhatmRoute = {
  types: `/khatms/types`,
  list: ({
    page = 1,
    pageSize = 15,
    search = '',
  }: {
    page: number
    pageSize?: number
    search?: string
  }) =>
    `${BASE_URL}/khatms?per_page=${pageSize}&page=${page}${
      search ? `&search=${search}` : ''
    }`,
  khatmDetail: (id: number) => `/khatms/${id}`,
  addToKhatm: (id: number) => `/khatms/${id}`,
  newKhatm: `/khatms`,
}
